import { ComponentType, OverlayConfig, OverlayRef } from '@angular/cdk/overlay';
import { ComponentRef, ElementRef, EmbeddedViewRef, Injector, Type, ViewContainerRef } from '@angular/core';
import { TemplateRef } from '@angular/core';
import { Observable } from 'rxjs';
import { ProgressbarProps } from './ad-progressbar.service';


export type DataInputType = {
  callbackBeforeClose?: Function;
  [key: string]: any;
};
export type DataTypeAssignedToComponent<T extends DataInputType> = T & {
  overlayRef: OverlayRef;
  closeOverlay: Function;
};
export type PortalComponentType<T extends DataInputType> = {
  data?: DataTypeAssignedToComponent<T>;
};

export interface ConfirmProps {
  message?: string,
  dialogTitle?: string,
  confirm?: () => void,
  cancel?: () => void,
  isCancelHidden?: boolean,
  confirmLabel?: string,
  cancelLabel?: string,
  details?: string[],
  closable?: boolean,
  dialogClass?: string,
}

export class TemplateProps {
  template: TemplateRef<any>;
  viewContainerRef?: ViewContainerRef;
  context?: any;
  dependedElement?: ElementRef | HTMLElement;
  hideOnDropbackClick?: boolean;
  config?: PanelOverlayConfig;
  callbackBeforeClose?: () => void;
}

export class PanelTemplateRef {
  overlayRef: OverlayRef;
  embeddedViewRef: EmbeddedViewRef<any>;
  api: AdMessageApi;
}

export class ComponentProps {
  component: ComponentType<any>;
  data?: { callbackBeforeClose?: () => void;[key: string]: any } | null;
  dependedComponent?: ElementRef | HTMLElement;
  hideOnDropbackClick?: boolean;
  config?: PanelOverlayConfig;
  inputs?: any;
  injector?: Injector;
  skipAnimation?: boolean;
  skipOverlayStyle?: boolean;
}

export class PanelComponentRef {
  overlayRef: OverlayRef;
  componentRef: ComponentRef<any>;
  api: AdMessageApi;
}

export interface IadMessageConfig
  extends IComponentConfig,
  ITemplateConfig,
  IInnerHTMLConfig,
  ITextConfig,
  IPComponent,
  IPTemplate {
  doNotShowAgainMsg?: string
}

export interface IDialogCloseProps {
  bodyInstance?: any,
  closeMe: () => void,
  doNotShowAgain?: boolean
}

export interface IDialogConfig {
  headerTemplate?: TemplateRef<any>;
  headerTemplateContext?: any;
  mainPathText?: string;
  secondaryPathText?: string;
  isShowMessageAgainVisible?: boolean;
  titleText?: string;
  secondaryPathCallBack?: any;
  messageStyle?: any;
  messageStyleClass?: any;
  titleClass?: any;
  isSecondaryButtonHidden?: boolean;
  isMainPathDisable?: () => boolean;
  isMainButtonDisable?: boolean;
  baseZIndex?: number;
  onOk?: (param: IDialogCloseProps) => void,
  onCancel?: (param: IDialogCloseProps) => void,
  closable?: boolean;
  closeOnEscape?: boolean;
  showHeader?: boolean;
  showOriginalHeader?: boolean;
}

export interface IPComponent extends IDialogConfig {
  componentType: Type<any>;
  inputs?: { [key: string]: any };
}

export interface IPTemplate extends IDialogConfig {
  bodyTemplate?: TemplateRef<any>;
  footerTemplate?: TemplateRef<any>;
  bodyTemplateContext?: any;
  footerTemplateContext?: any;
}

export interface IComponentConfig<T = any, R = T> extends IDialogConfig {
  componentType: Type<IAdMessageBody<T, R> | any>;
  componentViewModel?: any;
  // Deprecated suggest to use onOk instead
  mainPathCallBack?: (doNotShowAgain?: boolean, returnData?: R) => void;
  inputs?: { [key: string]: any };
}
export interface ITemplateConfig extends IDialogConfig {
  bodyTemplate?: TemplateRef<any>;
  bodyContext?: any;
  footerTemplate?: TemplateRef<any>;
  // Deprecated suggest to use onOk instead
  mainPathCallBack?: (doNotShowAgain?: boolean, returnData?: any) => void;
}
export interface IInnerHTMLConfig extends IDialogConfig {
  innerHtml?: string;
  // Deprecated suggest to use onOk instead
  mainPathCallBack?: (doNotShowAgain?: boolean, returnData?: any) => void;
}
export interface ITextConfig extends IDialogConfig {
  l1Text?: string;
  l2Text?: string | string[];
  // Deprecated suggest to use onOk instead
  mainPathCallBack?: (doNotShowAgain?: boolean, returnData?: any) => void;
}

export interface IConfirmProps {
  title?: string;
  message?: string;
  closable?: boolean;
  onOk?: () => void;
  onCancel?: () => void;
  okText?: string;
  cancelText?: string;
  bodyTemplate?: TemplateRef<any>;
  footerTemplate?: TemplateRef<any>;
}

export interface IAdMessageBody<T = any, R = T> {
  data?: T;
  isMainButtonDisable?: boolean;
  returnParam?: R;
}

export type PanelOverlayConfig = OverlayConfig & {
  zIndex?: number;
};

export const OVERLAYREF = 'Ad_OverlayRef';
export const CLOSEME = 'Ad_CloseMe';

export class AdMessageApi {
  overlayRef: OverlayRef;
  closeAdMessage: () => void;
}

export interface AdCautionParameter {
  message: string;
  confirmCallback: () => void;
  cancelCallback?: () => void;
  title?: string;
  titleIcon?: string;
  addtionalBodyTemplate?: TemplateRef<any>;
  footerTemplate?: TemplateRef<any>;
  confirmText?: string;
  confirmIcon?: string;
  cancelText?: string;
  cancelIcon?: string;
  isCancelHidden?: boolean;
  cautionContext?: ICautionContext;
  includeDefaultComment?: boolean;
  confirmBtnClass?: string;
  cancelBtnClass?: string;
  style?: any;
  footerClass?: string;
}

export interface ICautionContext {
  result?: any;
  confirmButtonDisable?: boolean;
}

export interface ProgressBarModalParm extends ProgressbarProps {
  title?: string;
  closable?: boolean;
}



export interface ProgressRunProps extends ProgressBarModalParm {
  asyncParams: Observable<any>[];
  onSuccess?: (param: any) => void;
  onFailed?: (param: any) => void;
  skipProgressManagement?: boolean;
  totalAsyncCount?: number;
}

export interface ProgressBarRef {
  updateValue: (number: number) => void;
  completeOneTask: () => void;
}

